<template>
  <div class="goodsDetails-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <div class="left-div">
        <el-card shadow="always">
          <img :src="dataObj.imgUrl" alt="">
        </el-card>
        <p class="sc">
          <i :class="dataObj.isSc ? 'el-icon-star-on' : 'el-icon-star-off'" @click="sc(dataObj.id, dataObj.isSc)"></i>
          {{dataObj.isSc ? '已收藏' : '未收藏'}}
        </p>
      </div>
      <div class="right-div">
        <h3 v-html="dataObj.name"></h3>
        <p class="summary" v-html="dataObj.summary" :style="{height: summaryShow ? '40px' : 'auto'}" :class="summaryShow ? 'style1' : ''" @click="summaryShow = !summaryShow"></p>
        <div class="money-div">
          <span>售&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</span>
          <span class="paperPrice">{{ dataObj.paperPriceOld ? dataObj.paperPriceOld : dataObj.paperPrice}}</span>
          <span class="paperPriceOld" v-show="dataObj.paperPriceOld ? true : false">
            定价：{{dataObj.paperPrice}}
          </span>
          <span class="e-book" v-show="dataObj.bookPrice">
            电子书价：
            <span class="bookPrice">{{ dataObj.paperPromotionPrice ? dataObj.paperPromotionPrice : dataObj.bookPrice}}</span>
            <span class="paperPriceOld" v-show="dataObj.paperPromotionPrice">
              定价：{{dataObj.bookPrice}}
            </span>
          </span>
        </div>
        <div class="starLevel-div">
          <div class="starLevel-left">
            <el-rate
              v-model="dataObj.starLevel"
              disabled
              show-score
              text-color="red"
              score-template="{value}颗星">
            </el-rate>
          </div>
          <div class="starLevel-right">
            <span class="pl">{{dataObj.plNum}}</span>
            <span class="xpl" @click="xpl">我要写评论</span>
          </div>
        </div>
        <p v-html="'作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者：'+ dataObj.bookAuthors"></p>
        <p v-html="'出&nbsp;&nbsp;版&nbsp;&nbsp;社：' + dataObj.press"></p>
        <p>
          出版时间：{{dataObj.time}}
        </p>
        <div class="btns">
          <button class="goShoppingCart" @click="addCart">
            <img :src="gwc" alt="">
            加入购物车
          </button>
          <button class="purchase" @click="purchaseImmediately">立即购买</button>
          <button v-show="dataObj.bookPrice" class="eBook-purchase" @click="dzs">
            <span v-if="dataObj.bookType == 14">视频购买</span>
            <span v-else-if="dataObj.bookType == 13">音频购买</span>
            <span v-else>电子书购买</span>
          </button>
          <button class="reading" v-show="dataObj.bookPrice" @click="reading(dataObj.id)">
            <span v-if="dataObj.bookType == 14">在线试看</span>
            <span v-else-if="dataObj.bookType == 13">在线试听</span>
            <span v-else>在线试读</span>
          </button>
        </div>
        <p>
          温馨提示：此类商品不支持退换
        </p>
      </div>
    </div>
    <div class="information">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="更多信息" name="info">
          <ol class="info-ol">
            <li>
              ISBN：{{ dataObj.ISBN }}
            </li>
            <li>
              字数：{{ dataObj.wordCount }}字
            </li>
            <li>
              版权方：{{ dataObj.copyrighterName }}
            </li>
          </ol>
        </el-tab-pane>
        <el-tab-pane label="作者简介" name="synopsis">
          <div class="synopsis-div" v-html="dataObj.bookAuthorsSummary">
          </div>
        </el-tab-pane>
        <el-tab-pane label="目录" name="catalog">
          <!-- <div v-html="dataObj.catalogue"></div> -->
          <ul style="list-style:none">
            <li v-for="(item, index) in dataObj.catalogue" :key="index" v-html="item"></li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="评论" name="comment">
          <ul class="comment-ul">
            <li v-for="(item, index) in commentList" :key="index">
              <div class="comment-left">
                {{item.userName}}
              </div>
              <div class="comment-right">
                <el-rate
                  v-model="item.starLevel"
                  disabled
                  show-score
                  text-color="red"
                  score-template="{value}颗星">
                </el-rate>
                <p class="comment-text">
                  {{item.comment}}
                </p>
                <p class="comment-time">
                  {{item.time}}
                </p>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 评论弹框 -->
    <el-dialog
      title="评论"
      :visible.sync="dialogVisible"
      width="400px"
      class="dialog"
      @close="dialogClose"
      :close-on-click-modal="false"
      center>
      <p>我对本书的评分是：</p>
      <p class="p-rate">
        <el-rate
          v-model="comment.val"
          text-color="red"
          show-score
          score-template="{value}颗星">
        </el-rate>
      </p>
      <el-input
        type="textarea"
        :rows="5"
        placeholder="说说你的看法吧~"
        v-model="comment.textarea">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <button class="fb" @click="fb">发表</button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
export default {
  name: '',
  components: {
    'menu-list': Menu
  },
  data () {
    return {
      comment: {
        val: 0,
        textarea: ''
      },
      gwc: require('@/assets/images/fl/gwc1.png'),
      activeName: 'info',
      currentPage: 1,
      total: 100,
      pageSize: 10,
      dialogVisible: false,
      bookId: '',
      dataObj: {},
      commentList: [],
      summaryShow: true
    }
  },
  methods: {
    handleClick () {},
    handleCurrentChange (val) { // 分页
      const start = (val - 1) * this.pageSize
      this.getComments(start)
    },
    xpl () { // 写评论弹出框
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        this.dialogVisible = true
      }
    },
    fb () { // 发布评论
      const bookId = this.bookId
      const userId = this.$store.state.userMsg.id
      const comments = this.comment.textarea
      const starLevel = this.comment.val
      const par = `?bookId=${bookId}&userId=${userId}&comments=${comments}&starLevel=${starLevel}`
      this.$get(this.$allUrl.addComment + par).then(res => {
        if (res.code === '0') {
          this.$notify({
            title: '成功',
            message: '评论成功',
            type: 'success',
            showClose: false,
            duration: 1500
          })
          this.dialogVisible = false
          this.getComments('0')
          this.dataObj.plNum += 1
        } else {
          this.$notify({
            title: '失败',
            message: '评论失败',
            type: 'info',
            showClose: false,
            duration: 1500
          })
        }
      })
    },
    dialogClose () { // 弹出框关闭后回调
      this.comment = {
        val: 0,
        textarea: ''
      }
    },
    getBookInfo () { // 获取书籍详情
      const userId = this.$store.state.userMsg.id
      const bookId = this.bookId
      const par = userId ? `?bookId=${bookId}&userId=${userId}` : `?bookId=${bookId}`
      this.$get(this.$allUrl.getBookInfo + par).then(res => {
        if (res.code === '0') {
          const data = res.data
          const imgAdmin = this.$allUrl.imgAdmin
          this.dataObj = {
            id: data.bookId,
            name: data.bookName,
            imgUrl: imgAdmin + data.coverUrl,
            summary: this.gl(data.bookSummary),
            paperPrice: data.paperPrice,
            paperPriceOld: data.promotionPrice,
            bookPrice: data.emark === 0 ? '' : data.bookPrice,
            starLevel: data.starLevel,
            plNum: data.commentNum,
            bookAuthors: data.bookAuthors,
            press: data.publisher,
            time: data.publishDate,
            isSc: data.favorite !== null,
            ISBN: data.isbn,
            wordCount: data.wordCount,
            copyrighterName: data.copyrighterName,
            catalogue: this.gl(data.catalogue).split('\n'),
            paperPromotionPrice: data.paperPromotionPrice,
            bookAuthorsSummary: data.bookAuthorsSummary,
            bookType: data.bookType
          }
        }
      })
    },
    gl (str) {
      return str
    },
    sc (id, state) { // 收藏
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        const bookId = id
        if (state) {
          this.deleteFavorite(bookId, userId)
        } else {
          this.addFavorite(bookId, userId)
        }
      }
    },
    addFavorite (bookId, userId) { // 用户添加收藏
      const par = `?bookId=${bookId}&userId=${userId}`
      this.$get(this.$allUrl.addFavorite + par).then(res => {
        if (res.code === '0') {
          this.$notify({
            title: '成功',
            message: '已成功收藏',
            type: 'success',
            showClose: false,
            duration: 1500
          })
          this.dataObj.isSc = true
        }
      })
    },
    deleteFavorite (bookId, userId) { // 用户取消收藏
      const par = `?bookId=${bookId}&userId=${userId}`
      this.$get(this.$allUrl.deleteFavorite + par).then(res => {
        if (res.code === '0') {
          this.$notify({
            title: '成功',
            message: '已取消收藏',
            type: 'success',
            showClose: false,
            duration: 1500
          })
          this.dataObj.isSc = false
        }
      })
    },
    getComments (start) { // 获取书籍评论
      const bookId = this.bookId
      const pageSize = this.pageSize
      const par = `?bookId=${bookId}&start=${start}&num=${pageSize}`
      this.$get(this.$allUrl.getComments + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          this.total = res.recordsTotal
          this.commentList = []
          list.forEach(e => {
            this.commentList.push({
              id: e.id,
              userName: e.userName,
              starLevel: e.starLevel,
              comment: e.comments,
              time: e.createtime
            })
          })
        }
      })
    },
    addCart () { // 加入购物车
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        const bookId = this.bookId
        const par = `?bookId=${bookId}&userId=${userId}&type=0`
        const bookPrice = this.dataObj.bookPrice
        this.$get(this.$allUrl.addCart + par).then(res => {
          if (res.code === '0') {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$root.eventHub.$emit('update_shoppingNum')
          } else {
            this.$message.error('添加失败')
          }
        })
        if (bookPrice) {
          const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
          this.$get(this.$allUrl.addCart + par2).then(res => {
            if (res.code !== '0') {
              this.$message.error('电子书加入购物车失败')
            }
          })
        }
      }
    },
    dzs () {
      let list = [{
        id: this.dataObj.id,
        name: this.dataObj.name,
        imgUrl: this.dataObj.imgUrl,
        describe: this.dataObj.summary,
        author: this.dataObj.bookAuthors,
        money: this.dataObj.paperPromotionPrice ? this.dataObj.paperPromotionPrice : this.dataObj.bookPrice,
        num: 1,
        totalPrice: this.dataObj.paperPromotionPrice ? this.dataObj.paperPromotionPrice : this.dataObj.bookPrice
      }]
      this.$router.push({
        path: '/home/orderdetails',
        query: {
          list: JSON.stringify(list),
          payAmount: list[0].totalPrice,
          bookType: '1'
        }
      })
    },
    purchaseImmediately () { // 立即购买
      let list = [{
        id: this.dataObj.id,
        name: this.dataObj.name,
        imgUrl: this.dataObj.imgUrl,
        describe: this.dataObj.summary,
        author: this.dataObj.bookAuthors,
        money: this.dataObj.paperPriceOld ? this.dataObj.paperPriceOld : this.dataObj.paperPrice,
        num: 1,
        totalPrice: this.dataObj.paperPriceOld ? this.dataObj.paperPriceOld : this.dataObj.paperPrice
      }]
      this.$router.push({
        path: '/home/orderdetails',
        query: {
          list: JSON.stringify(list),
          payAmount: this.dataObj.paperPriceOld ? this.dataObj.paperPriceOld : this.dataObj.paperPrice,
          bookType: '0'
        }
      })
    },
    reading (id) { // 在线试读
      let routeData = this.$router.resolve({
        name: 'Book',
        query: {
          bookId: id,
          type: 1
        }
      })
      window.open(routeData.href, '_blank')
      // window.open('/book?bookId=' + `${id}&type=1`)
    }
  },
  mounted () {
    this.bookId = this.$route.query.id
    if (this.bookId) {
      this.getBookInfo()
      this.getComments(0)
    }
  }
}
</script>
<style lang="less" scoped>
  .goodsDetails-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      margin-top: 50px;
      display: flex;
      padding: 0 10px;
      .left-div{
        width: 280px;
        img{
          width: 100%;
          height: 100%;
          min-width: 238px;
          min-height: 318px;
        }
        .sc{
          text-align: center;
          font-size: 14px;
          i{
            cursor: pointer;
            font-size: 20px;
          }
        }
      }
      .right-div{
        padding-left: 30px;
        width: 600px;
        color: #000000;
        p{
          padding: 0;
          margin: 0 0 15px 0;
          color: #666666;
          font-size: 13px;
        }
        h3{
          padding: 0 0 5px 0;
          margin: 0;
          border-bottom: 1px solid #b60e0e;
          font-size: 18px;
          display: inline-block;
        }
        .summary{
          font-size: 16px;
          margin: 20px 0;
          cursor: pointer;
          overflow: hidden;
          position: relative;
        }
        .style1::after{
          content: '...';
          position: absolute;
          right: 0;
          top: 25px;
          background: white;
        }
        .money-div{
          background-color: #F0F0F0;
          padding: 15px;
          font-size: 13px;
          .paperPrice{
            color: #b60e0e;
            font-size: 20px;
            font-weight: 600;
          }
          .paperPrice:before{
            content: '￥';
            font-size: 12px;
          }
          .paperPriceOld{
            text-decoration: line-through;
            color: #807e7e;
          }
          .e-book{
            margin-left: 30px;
            .bookPrice{
              color: #004bc7;
              font-size: 20px;
              font-weight: 600;
            }
            .bookPrice:before{
              content: '￥';
              font-size: 12px;
            }
          }
        }
        .starLevel-div{
          padding: 15px 0;
          display: flex;
          .starLevel-right{
            font-size: 14px;
            padding-left: 30px;
            .pl{
              color: #b60e0e;
            }
            .pl::after{
              content: '条读者评论';
              color: #000000;
            }
            .xpl{
              background-color: #fdb916;
              color: white;
              padding: 2px 5px 0 5px;
              font-size: 12px;
              border-radius: 4px;
              cursor: pointer;
            }
          }
        }
        .btns{
          margin: 32px 0 20px 0;
          button{
            outline: none;
            height: 35px;
            font-size: 16px;
            border-radius: 6px;
            cursor: pointer;
            vertical-align: middle;
            width: 127px;
            margin-right: 18px;
          }
          .goShoppingCart{
            border: 1px solid #b60e0e;
            background-color: white;
            color: #b60e0e;
            img{
              width: 20px;
              vertical-align: middle;
              margin-top: -3px;
            }
          }
          .purchase{
            border: 1px solid #B7151E;
            background-color: #B7151E;
            color: white;
          }
          .eBook-purchase{
            border: 1px solid #194A94;
            background-color: #194A94;
            color: white;
          }
          .reading{
            border: 1px solid #194A94;
            background-color: white;
            color: #194A94;
          }
        }
      }
    }
    .information{
      margin-top: 30px;
      padding: 0 10px 50px 10px;
      .info-ol{
        list-style: none;
        color: #666666;
        font-size: 14px;
        li{
          padding-bottom: 5px;
        }
      }
      .synopsis-div{
        font-size: 14px;
        color: #666666;
        padding: 10px 0;
      }
      .comment-ul{
        padding: 0;
        margin: 0;
        list-style: none;
        li{
          display: flex;
          border-bottom: 2px solid #E6E6E6;
          padding: 20px 0;
          .comment-left{
            width: 200px;
            font-size: 18px;
            font-weight: 600px;
            text-align: center;
            padding: 0 20px;
          }
          .comment-right{
            flex: 1;
            padding-right: 100px;
            p{
              color: #666666;
            }
            .comment-text{
              font-size: 14px;
            }
            .comment-time{
              text-align: right;
              font-size: 16px;
              margin-bottom: 0;
            }
          }
        }
      }
      .pagination{
        text-align: right;
        padding: 50px 0;
      }
    }
    .dialog{
      .p-rate{
        text-align: center;
      }
      .fb{
        background-color: #B7151E;
        border: 0;
        cursor: pointer;
        outline: none;
        color: white;
        border-radius: 6px;
        padding: 8px 30px;
        font-size: 16px;
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/GoodsDetails/goodsDetails.vue


// WEBPACK FOOTER //
// src/components/GoodsDetails/goodsDetails.vue